import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';

const PAGE_H = 842;
const CB_X = 286;     // left edge — inside the | | markers (x≈285.5–296.7)
const CB_SIZE = 9;    // checkbox cell size in pt

// fromTop = distance from page top to the CENTER of the | | marker
// We draw the rectangle centered on that point, shifted 3pt down to align visually.
function pdfY(fromTop: number): number {
  return PAGE_H - fromTop - CB_SIZE / 2 - 2;
}

// ── All checkbox positions ────────────────────────────────────────────────────
// fromTop = center of the | | text marker (extracted from original PDF)

export const CB_POSITIONS: Record<string, { page: number; fromTop: number }> = {
  // === Gleichstellung der Geschlechter ===
  // Q1 Genderkompetenz
  g_komp_fortb:     { page: 0, fromTop: 221.0 },
  g_komp_sensi:     { page: 0, fromTop: 244.4 },
  g_komp_nein:      { page: 0, fromTop: 267.9 },
  // Q2 Geschlechterparität
  g_parit_teams:    { page: 0, fromTop: 291.4 },
  g_parit_partner:  { page: 0, fromTop: 327.6 },
  g_parit_nein:     { page: 0, fromTop: 389.0 },
  // Q3 Gendersensible Ansätze
  g_sens_ansprache: { page: 0, fromTop: 412.5 },
  g_sens_didaktik:  { page: 0, fromTop: 448.6 },
  g_sens_segreg:    { page: 0, fromTop: 484.9 },
  g_sens_digital:   { page: 0, fromTop: 541.3 },
  g_sens_nein:      { page: 0, fromTop: 577.4 },
  // Q4 Geschlechterstereotypen
  g_stereo_beruf:   { page: 0, fromTop: 600.9 },
  g_stereo_berat:   { page: 0, fromTop: 624.3 },
  g_stereo_famil:   { page: 0, fromTop: 647.8 },
  g_stereo_andere:  { page: 0, fromTop: 671.4 },
  g_stereo_nein:    { page: 0, fromTop: 694.9 },
  // Q5 Strukturelle Ungleichheiten
  g_ungl_orgentw:   { page: 0, fromTop: 718.4 },
  g_ungl_arbvol:    { page: 1, fromTop:  80.6 },
  g_ungl_arbeitsm:  { page: 1, fromTop: 129.4 },
  g_ungl_aufstieg:  { page: 1, fromTop: 174.4 },
  g_ungl_nein:      { page: 1, fromTop: 210.6 },
  // Q6 Vereinbarkeitsfragen
  g_verein_care:    { page: 1, fromTop: 234.1 },
  g_verein_kinderb: { page: 1, fromTop: 280.4 },
  g_verein_nein:    { page: 1, fromTop: 329.1 },

  // === Antidiskriminierung ===
  // Q7 Zielgruppe
  ad_zielgr_migr:    { page: 1, fromTop: 406.8 },
  ad_zielgr_behindr: { page: 1, fromTop: 442.9 },
  ad_zielgr_andere:  { page: 1, fromTop: 479.0 },
  ad_zielgr_keine:   { page: 1, fromTop: 512.7 },
  // Q8 Strukturelle Diskriminierungsrisiken
  ad_diskr_arbm:     { page: 1, fromTop: 546.3 },
  ad_diskr_org:      { page: 1, fromTop: 579.9 },
  ad_diskr_bildung:  { page: 1, fromTop: 616.2 },
  ad_diskr_dienst:   { page: 1, fromTop: 652.3 },
  ad_diskr_nein:     { page: 1, fromTop: 685.9 },
  // Q9 Barrierefreiheit
  ad_barr_zugang:    { page: 1, fromTop: 709.4 },
  ad_barr_methodik:  { page: 1, fromTop: 745.5 },
  ad_barr_oeffe:     { page: 1, fromTop: 769.0 },
  ad_barr_nein:      { page: 2, fromTop:  80.6 },
  // Q10 AGG / Umsetzungsschritte
  ad_agg_agg:        { page: 2, fromTop: 104.1 },
  ad_agg_behindr:    { page: 2, fromTop: 160.5 },
  ad_agg_eu:         { page: 2, fromTop: 205.5 },
  ad_agg_nein:       { page: 2, fromTop: 250.5 },
  // Q11 Projektmitarbeiter Antidiskriminierung
  ad_proj_ja:        { page: 2, fromTop: 274.0 },
  ad_proj_nein:      { page: 2, fromTop: 294.9 },

  // === Ökologische Nachhaltigkeit ===
  // Q12 Veranstaltungen
  oe_veranst_oepnv:     { page: 2, fromTop: 381.6 },
  oe_veranst_cater:     { page: 2, fromTop: 414.9 },
  oe_veranst_virtu:     { page: 2, fromTop: 448.4 },
  oe_veranst_krit:      { page: 2, fromTop: 481.9 },
  oe_veranst_nein:      { page: 2, fromTop: 505.2 },
  // Q13 Beschaffung
  oe_beschaff_umw:      { page: 2, fromTop: 528.4 },
  oe_beschaff_zert:     { page: 2, fromTop: 561.9 },
  oe_beschaff_leben:    { page: 2, fromTop: 597.8 },
  oe_beschaff_krit:     { page: 2, fromTop: 633.8 },
  oe_beschaff_nein:     { page: 2, fromTop: 658.2 },
  // Q14 Ressourcenschonung
  oe_ressource_mull:    { page: 2, fromTop: 679.5 },
  oe_ressource_recycl:  { page: 2, fromTop: 713.0 },
  oe_ressource_strom:   { page: 2, fromTop: 746.4 },
  oe_ressource_energie: { page: 3, fromTop:  80.5 },
  oe_ressource_nein:    { page: 3, fromTop: 103.8 },
  // Q15 Umweltschutz & Mobilität
  oe_mob_oepnv:         { page: 3, fromTop: 127.0 },
  oe_mob_zug:           { page: 3, fromTop: 163.0 },
  oe_mob_dienst:        { page: 3, fromTop: 186.3 },
  oe_mob_nein:          { page: 3, fromTop: 222.2 },
  // Q16 Kompetenz Nachhaltigkeit
  oe_komp_fortb:        { page: 3, fromTop: 245.5 },
  oe_komp_sensi:        { page: 3, fromTop: 279.0 },
  oe_komp_nein:         { page: 3, fromTop: 302.2 },
};

/** Generate filled PDF: loads original, draws X at each selected checkbox */
export async function generateFilledPdf(selected: string[]): Promise<Uint8Array> {
  const res = await fetch('/esf-fragebogen.pdf', { cache: 'no-store' });
  if (!res.ok) throw new Error('Formular konnte nicht geladen werden');
  const bytes = await res.arrayBuffer();

  const pdf = await PDFDocument.load(bytes);
  const pages = pdf.getPages();
  const font = await pdf.embedFont(StandardFonts.HelveticaBold);

  for (const name of selected) {
    const pos = CB_POSITIONS[name];
    if (!pos) continue;
    const page = pages[pos.page];
    const yPdf = pdfY(pos.fromTop);

    // Draw a filled dark-blue square centered on the | | marker
    page.drawRectangle({
      x: CB_X + 0.5,
      y: yPdf + 0.5,
      width: CB_SIZE - 1,
      height: CB_SIZE - 1,
      color: rgb(0.07, 0.26, 0.55),
    });
    // Draw white "X" centred inside
    page.drawText('X', {
      x: CB_X + 1.8,
      y: yPdf + 1.5,
      size: 6.5,
      font,
      color: rgb(1, 1, 1),
    });
  }

  return pdf.save();
}
